import { QUERY_KEYS } from "@/libraries/constant";
import { getCasesQueryOptions } from "@/queries";
import { CaseSearchParamSchema } from "@/schemas";
import { onlineManager } from "@tanstack/react-query";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { zodSearchValidator } from "@tanstack/router-zod-adapter";
import AppBarCase from "../-components/AppBar";

export const Route = createFileRoute("/dashboard/case/records")({
	validateSearch: zodSearchValidator(CaseSearchParamSchema),
	loader: ({ context, location }) => {
		if (onlineManager.isOnline() && !context.isRestoring) {
			return context.queryClient.ensureInfiniteQueryData(
				getCasesQueryOptions({
					status: location.pathname.endsWith("closed") ? "closed" : "active",
				}),
			);
		}
		return context.queryClient.getQueryData([
			QUERY_KEYS.GET_CASES,
			{
				status: location.pathname.endsWith("closed") ? "closed" : "active",
			},
		]);
	},
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<div className="relative flex-1 flex flex-col overflow-hidden">
			<AppBarCase variant="records" info="Select a case to view its record" />
			<Outlet />
		</div>
	);
}
